import React, { useState, useEffect } from "react";
import QuizModal from "../../components/quizz/QuizModal";
import { BsPlusCircleFill } from "react-icons/bs";
import { DEFAULT_ROUTE } from "../../routes/api/api_routes";


const QuestionsView = () => {
  const [questions, setQuestions] = useState([]);
  const [filteredQuestions, setFilteredQuestions] = useState([]); // 🔹 Questions filtrées
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [error, setError] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const questionsPerPage = 6;
  const [selectedTech, setSelectedTech] = useState("All"); // 🔹 Technologie sélectionnée

  // 🔹 Fonction pour récupérer les questions
  const fetchQuestions = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("access");
      const res = await fetch(`${DEFAULT_ROUTE}admin/questions/`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `JWT ${token}`,
        },
      });
      if (!res.ok) {
        throw new Error("Erreur lors de la récupération des questions");
      }
      const data = await res.json();
      setQuestions(data);
      setFilteredQuestions(data); // 🔹 Par défaut, toutes les questions
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchQuestions();
  }, []);

  // 🔹 Appelé lorsque le modal se ferme
  const handleModalClose = () => {
    setIsModalOpen(false);
    fetchQuestions(); // refetch les questions
  };

  // 🔹 Filtrage par technologie
  const handleFilter = (techName) => {
    setSelectedTech(techName);
    if (techName === "All") {
      setFilteredQuestions(questions);
    } else {
      setFilteredQuestions(
        questions.filter((q) => q.technology?.name === techName)
      );
    }
    setCurrentPage(1); // reset pagination
  };

  // 🔹 Pagination
  const indexOfLastQuestion = currentPage * questionsPerPage;
  const indexOfFirstQuestion = indexOfLastQuestion - questionsPerPage;
  const currentQuestions = filteredQuestions.slice(
    indexOfFirstQuestion,
    indexOfLastQuestion
  );
  const totalPages = Math.ceil(filteredQuestions.length / questionsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // 🔹 Extraire toutes les technologies uniques
  const technologies = [
    "All",
    ...new Set(questions.map((q) => q.technology?.name).filter(Boolean)),
  ];

  return (
    <div className="p-1">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-semibold m-0">Liste des questions</h2>
        <button
          onClick={() => setIsModalOpen(true)}
          className="flex items-center gap-2 border border-orange-400 text-black px-4 py-2 rounded hover:bg-orange-50"
        >
          <BsPlusCircleFill className="text-orange-400" /> Ajouter
        </button>
      </div>

      {/* 🔹 Boutons de filtrage */}
      <div className="flex flex-wrap gap-2 mb-4">
        {technologies.map((tech) => (
          <button
            key={tech}
            onClick={() => handleFilter(tech)}
            className={`px-4 py-1 rounded ${
              selectedTech === tech
                ? "bg-teal-600 text-white"
                : "bg-gray-200 hover:bg-gray-300"
            }`}
          >
            {tech}
          </button>
        ))}
      </div>

      {loading ? (
        <table className="w-full border-collapse">
          <tbody>
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <tr key={i} className="border-t bg-gray-200">
                <td className="p-3">&nbsp;</td>
                <td className="p-3">&nbsp;</td>
                <td className="p-3">&nbsp;</td>
                <td className="p-3">&nbsp;</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : error ? (
        <p className="text-red-500">{error}</p>
      ) : (
        <>
          {/* Tableau */}
          <table className="w-full border-collapse">
            <thead className="bg-teal-600">
              <tr>
                <th className="p-3 text-left text-white">ID</th>
                <th className="p-3 text-left text-white">Question</th>
                <th className="p-3 text-left text-white">Technologie</th>
                <th className="p-3 text-left text-white">Niveau</th>
              </tr>
            </thead>
            <tbody>
              {currentQuestions.map((q) => (
                <tr key={q.id} className="border-t hover:bg-gray-50">
                  <td className="p-3">{q.id}</td>
                  <td className="p-3">{q.html}</td>
                  <td className="p-3">{q.technology?.name || "—"}</td>
                  <td className="p-3">{q.niveau?.name || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Pagination */}
          <div className="flex justify-center items-center mt-4 space-x-2">
            <button
              disabled={currentPage === 1}
              onClick={() => handlePageChange(currentPage - 1)}
              className="px-3 py-1 bg-teal-600 rounded text-white disabled:bg-gray-300"
            >
              Précédent
            </button>

            {Array.from({ length: totalPages }, (_, index) => (
              <button
                key={index + 1}
                onClick={() => handlePageChange(index + 1)}
                className={`px-3 py-1 rounded ${
                  currentPage === index + 1
                    ? "bg-teal-600 text-white"
                    : "bg-gray-200"
                }`}
              >
                {index + 1}
              </button>
            ))}

            <button
              disabled={currentPage === totalPages}
              onClick={() => handlePageChange(currentPage + 1)}
              className="px-3 py-1 bg-teal-600 text-white rounded disabled:bg-gray-300"
            >
              Suivant
            </button>
          </div>
        </>
      )}

      {isModalOpen && (
        <QuizModal
          onClose={handleModalClose}
          onQuestionCreated={fetchQuestions}
        />
      )}
    </div>
  );
};

export default QuestionsView;
